import React, {memo, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styles from './index.less';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import {Card, Form, Input} from 'antd';
import FormBuilder from 'antd-form-builder';
import {useAuditData} from '@/modules/auditorAudits/hooks/useAuditData';
import {EntityDetailContent} from '@/components/EntityDetailContent';
import {useFieldsContactInformation} from '@/modules/templates/hooks/audits/useFieldsContactInformation';

const TemplateDetailContactInformation = ({question, runAudit}) => {
  const {t} = useTranslation('templates');
  // eslint-disable-next-line no-unused-vars
  const forceUpdate = FormBuilder.useForceUpdate();
  const [form] = Form.useForm();
  const {currentAudit} = useAuditData();
  const {id} = useParams();
  const [value, setValue] = useState([]);

  useEffect(() => {
    const contactValue = currentAudit?.contactFields?.find(x => x?._id === question?._id)?.value;

    if (contactValue) {
      setValue(contactValue);
    }
  }, [currentAudit?.contactFields, question?._id]);

  const fields = useFieldsContactInformation(!runAudit, form, question, runAudit, id, currentAudit );

  return (
    <Card
      className={styles.templateAuditorCard}
      id={'question-view-' + question?._id}
    >
      <div className="mb-3">
        {t('details.contactInformation')}
      </div>

      <div className="custom-form-big">
        {runAudit && currentAudit?._id
          ? (
            <div className={'flex flex-row'}>
              <Form
                form={form}
                // onFinish={onSave}
                layout={!runAudit ? 'vertical' : 'horizontal'}
                className="custom-form w-full"
                scrollToFirstError
                onValuesChange={ forceUpdate }>
                <EntityDetailContent
                  viewMode={!runAudit || false}
                  form={form}
                  data={value}
                  fields={fields}
                />
              </Form>
            </div>
          )
          : <Input defaultValue={value}/>
        }
      </div>
    </Card>
  );
};

TemplateDetailContactInformation.propTypes = {
  runAudit: PropTypes.bool,
  sectionId: PropTypes.string,
  question: PropTypes.object,
  isCover: PropTypes.bool,
  section: PropTypes.object,
};
TemplateDetailContactInformation.defaultProps = {
  entity: {},
};

export default memo(TemplateDetailContactInformation);


/**
 * cellRender
 * */
/**
 * This is not a components,
 * it is a function to render the Detail Audit Card components in a detail drawer
 * @param {String} value this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} entity this is the row instance
 * */
export const renderTemplateDetailContactInformation = (value, entity) => {
  return (
    <TemplateDetailContactInformation entity={entity}/>
  );
};
